<div class="card mb-4 flex flex-col gap-4" data-testid="rfp-suitability-panel">
  <div class="flex flex-wrap items-start justify-between gap-4">
    <div class="flex flex-col gap-1">
      <h2 class="text-xl font-semibold">
        {{ 'project.steps.rfp.invitationList.matrix.title' | transloco }}
      </h2>
      <span class="text-muted-color text-sm">
        {{ 'project.steps.rfp.invitationList.matrix.subtitle' | transloco }}
      </span>
    </div>
    <app-model-field-select-button
      id="suitability-mode"
      [options]="modeOptions"
      optionLabel="labelKey"
      optionValue="value"
      [allowEmpty]="false"
      [(value)]="mode"
    />
  </div>

  <div class="bg-second-level flex flex-wrap items-end justify-between gap-4 rounded-lg p-4">
    <div class="flex flex-col gap-1">
      <span class="text-sm font-semibold">
        {{ 'project.steps.rfp.invitationList.matrix.thresholds' | transloco }}
      </span>
      <span class="text-muted-color text-xs">
        {{ 'project.steps.rfp.invitationList.matrix.thresholdsHint' | transloco }}
      </span>
    </div>
    <div class="flex flex-wrap items-end gap-6">
      <div class="w-40">
        <app-model-field-percentage
          id="coverage-threshold"
          label="project.steps.rfp.invitationList.matrix.minCoverage"
          [smallLabel]="true"
          [maxFractionDigits]="0"
          [value]="coverageThreshold()"
          (valueChange)="setCoverageThreshold($event)"
        />
      </div>
      <div class="w-40">
        <app-model-field-percentage
          id="rfi-threshold"
          label="project.steps.rfp.invitationList.matrix.minRfi"
          [smallLabel]="true"
          [maxFractionDigits]="0"
          [value]="rfiThreshold()"
          (valueChange)="setRfiThreshold($event)"
        />
      </div>
    </div>
  </div>

  <div class="grid grid-cols-1 gap-4 xl:grid-cols-[minmax(0,2fr)_minmax(18rem,1fr)]">
    <div class="flex flex-col gap-2">
      <app-rfp-suitability-matrix
        [tools]="tools()"
        [mode]="mode()"
        [thresholds]="thresholds()"
        [selectedToolId]="matrixSelectedToolId()"
        (selectedToolIdChange)="selectedToolId.set($event)"
      />
      <app-color-legend [entries]="legendEntries">
        <span>{{ 'project.steps.rfp.invitationList.matrix.circleSize' | transloco }}</span>
      </app-color-legend>
    </div>

    @if (selectedTool(); as tool) {
      <div class="flex flex-col gap-4" data-testid="selected-tool-panel">
        <app-rfp-selected-tool-card
          [tool]="tool"
          [tools]="tools()"
          [preferred]="selectedToolPreferred()"
          [locked]="locked()"
          (toolChange)="selectedToolId.set($event)"
          (selectionChange)="selectionChange.emit($event)"
        />
        <div class="card flex flex-col gap-2 p-4 text-sm">
          <h3 class="font-semibold">
            {{ 'project.steps.rfp.invitationList.matrix.logicTitle' | transloco }}
          </h3>
          <span class="text-muted-color">
            {{ 'project.steps.rfp.invitationList.matrix.logicCoverage' | transloco }}
          </span>
          <span class="text-muted-color">
            {{ 'project.steps.rfp.invitationList.matrix.logicCompleteness' | transloco }}
          </span>
          <span class="text-muted-color">
            {{ 'project.steps.rfp.invitationList.matrix.summary' | transloco: summaryParams() }}
          </span>
        </div>
      </div>
    }
  </div>
</div>
